import React from 'react';
import styles from './mediaOverlay.scss';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../types';
import { Carousel } from 'react-responsive-carousel';
import classNames from 'classnames';
import CrossRing from '../icons/crossRing';
import IconArrowCircleGreyLeft from '../icons/icon_arrow_circle_grey_left';
import IconArrowCircleGreyRight from '../icons/icon_arrow_circle_grey_right';
import '../../styles/customCarouselStyles.scss';

const MediaOverlay = inject('store')(
    observer(({ store }: IInjectedProps) => {
        function closeMediaOverlay(): void {
            store?.mixedMediaStore?.updateMediaOverlayVisibility(false);
            store?.mixedMediaStore?.mainStore.scrollLock.unlock();
            store?.mixedMediaStore?.mainStore.showEsAppButton();
        }


        const renderArrowPrev = (onClickHandler, hasPrev) =>
            hasPrev && (
                <div data-testid='carousel-arrow-prev'
                  data-semantic-id='carousel-arrow-prev' className={'control_arrow a_previous'} onClick={onClickHandler}
                    // ref={(el) => tabNavigation.setFocusAtt(el)}
                    // onKeyDown={tabNavigation.handleKeyDown}
                    >
                    <IconArrowCircleGreyLeft />
                </div>
            );

        const renderArrowNext = (onClickHandler, hasPrev) =>
            hasPrev && (
                <div data-testid='carousel-arrow-next'
                  data-semantic-id='carousel-arrow-next' className={'control_arrow a_next'} onClick={onClickHandler}
                    // ref={(el) => tabNavigation.setFocusAtt(el)}
                    // onKeyDown={tabNavigation.handleKeyDown}
                    >
                    <IconArrowCircleGreyRight />
                </div>
            );

        if (store?.mixedMediaStore?.displayMediaOverlay)
            return (
                <div className={styles.media_overlay}>
                    <div className={styles.cross_icon} onClick={closeMediaOverlay}>
                        <CrossRing />
                    </div>
                    <div className={styles.media_overlay_content}>
                        <Carousel
                            showArrows={true}
                            showIndicators={true}
                            showStatus={false}
                            className='desktop_carousel'
                            infiniteLoop={true}
                            selectedItem={store?.mixedMediaStore?.getMediaOverlayImageIndex}
                            renderArrowPrev={renderArrowPrev}
                            renderArrowNext={renderArrowNext}>
                            {store?.mixedMediaStore.mediaOverlayImages.map((image, index) => {
                                return (
                                    <img key={index} className={classNames('contain', 'slide_image')} 
                                        src={image.imgPath} />
                                );
                            })}
                        </Carousel>
                    </div>
                </div>)
        else
            return null;
    })
);
export default MediaOverlay;

